'use strict';

var b=Object.defineProperty;var g=Object.getOwnPropertySymbols;var w=Object.prototype.hasOwnProperty,O=Object.prototype.propertyIsEnumerable;var m=(e,n,t)=>n in e?b(e,n,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[n]=t,a=(e,n)=>{for(var t in n||(n={}))w.call(n,t)&&m(e,t,n[t]);if(g)for(var t of g(n))O.call(n,t)&&m(e,t,n[t]);return e};var S=()=>new Date().toISOString();var B=()=>typeof window!="undefined",D=()=>typeof window=="undefined";var U=(e,n)=>{let t=new Map;return e.forEach(r=>{let o=n(r);if(o){let s=t.get(o);s?s.push(r):t.set(o,[r]);}}),t},z=(e,n,t)=>[...e.slice(0,n),t,...e.slice(n+1)],C=(e,n,t)=>[...e.slice(0,n),t,...e.slice(n)],E=(e,n)=>[...e.slice(0,n),...e.slice(n+1)],I=(e=[])=>e[0],J=(e=[])=>e[e.length-1],L=(e,n,t)=>{let r=Array.from(e),[o]=r.splice(n,1);return r.splice(t,0,o),r};function G(){return null}function R(e){return e}function W(e){return e==null||typeof e=="object"&&Object.keys(e).length===0||typeof e=="string"&&e.trim().length===0}function _(e){return (n,t)=>n[e]>t[e]?1:t[e]>n[e]?-1:0}function q(e){return (n,t)=>n[e]<t[e]?1:t[e]<n[e]?-1:0}var H=e=>JSON.parse(JSON.stringify(e)),Q=(e,n,t=1)=>Array.from({length:(n-e)/t+1},(r,o)=>e+o*t),X=e=>typeof e=="string",y=e=>Array.isArray(e),h=e=>typeof e=="function";function Y(e){return !!e}var A=e=>y(e)?e.filter(Boolean):[],Z=e=>y(e)&&e.length===0,k=e=>typeof e=="object",ee=e=>i(e)&&h(e.then),p=e=>e===void 0,F=e=>e===null,d=e=>F(e)||p(e),i=e=>!d(e)&&!y(e)&&k(e);function ne(e){if(!i(e))return !1;let n=Object.getPrototypeOf(e);return n!==null&&Object.getPrototypeOf(n)===null}var N=e=>A(e.replace(/["|']|\]/g,"").split(/\.|\[/)),v=e=>/^\w*$/.test(e);function te(e,n,t){let r=v(n)?[n]:N(n),s=r.length-1,T=a({},e);return r.reduce((u,c,f)=>{if(f!==s){let l=u[c],x=Array.isArray(l)?[...l]:i(l)?a({},l):isNaN(+r[f+1])?{}:[];return u[c]=x,x}else return u[c]=t,u},T),T}var re=(e,n,t)=>{if(!n||!i(e))return t;let r=A(n.split(/[,[\].]+?/)).reduce((o,s)=>d(o)?o:o[s],e);return p(r)||r===e?p(e[n])?t:e[n]:r};function j(e,n,t=new WeakMap,r={}){for(let o of Object.keys(e)){let s=e[o];i(s)?t.get(s)||(t.set(s,!0),r[o]=Array.isArray(s)?[]:{},j(s,n,t,r[o])):r[o]=n;}return r}var P=e=>typeof e=="function",ie=(e,n)=>P(e)?e(n):e;var V=(e="")=>e.toLowerCase().normalize("NFD").replace(/([\u0300-\u036f]|\s+)/g,""),le=(e="",n="")=>V(e).includes(V(n)),ce=(e="")=>e.charAt(0).toUpperCase()+e.slice(1);function ae(e){let n=e.trim().split(" ");return n.reduce((r,o,s)=>((s===0||s===n.length-1)&&(r=`${r}${o.charAt(0)}`),r),"").toUpperCase()}function pe(e,n=0){let t=[{value:1,symbol:""},{value:1e3,symbol:"k"},{value:1e6,symbol:"M"},{value:1e9,symbol:"G"},{value:1e12,symbol:"T"},{value:1e15,symbol:"P"},{value:1e18,symbol:"E"}],r=/\.0+$|(\.[0-9]*[1-9])0+$/;var o=t.slice().reverse().find(s=>e>=s.value);return o?(e/o.value).toFixed(n).replace(r,"$1")+o.symbol:"0"}function ye(e,n=0){return (e*100).toFixed(n)+"%"}function Te(e){return e.replace(/\/$/,"")}

exports.addAt = C;
exports.capitalize = ce;
exports.clone = H;
exports.compact = A;
exports.empty = W;
exports.first = I;
exports.get = re;
exports.groupBy = U;
exports.identity = R;
exports.includes = le;
exports.initials = ae;
exports.isArray = y;
exports.isBrowser = B;
exports.isEmptyArray = Z;
exports.isFunction = h;
exports.isKey = v;
exports.isNull = F;
exports.isNullOrUndefined = d;
exports.isObject = i;
exports.isObjectType = k;
exports.isPlainObject = ne;
exports.isPromise = ee;
exports.isServer = D;
exports.isString = X;
exports.isTruthy = Y;
exports.isUndefined = p;
exports.last = J;
exports.noop = G;
exports.normalize = V;
exports.now = S;
exports.percentage = ye;
exports.range = Q;
exports.removeAt = E;
exports.removeTrailingSlash = Te;
exports.reorder = L;
exports.replaceAt = z;
exports.resolve = ie;
exports.set = te;
exports.setNestedObjectValues = j;
exports.sortByKey = _;
exports.sortByKeyDesc = q;
exports.stats = pe;
exports.stringToPath = N;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map